import React from 'react';
import { Box, useTheme } from '@mui/material';
import type { WorkflowStatusId } from 'types/workflow/workflow-status';
import { workflowStatusMeta } from './workflow-status-meta';

type WorkflowStatusIconBadgeProps = {
  status: WorkflowStatusId;
  /** גודל האייקון הפנימי (px) */
  size?: number;
};

/** תג צבעוני + אייקון MUI — אותו סט כמו במרכז המידע (workflow-flow-statuses) */
export const WorkflowStatusIconBadge: React.FC<WorkflowStatusIconBadgeProps> = ({ status, size = 22 }) => {
  const theme = useTheme();
  const meta = workflowStatusMeta(status);
  if (!meta) return null;
  const Icon = meta.Icon;
  const boxSize = size + 10;

  return (
    <Box
      sx={{
        width: boxSize,
        height: boxSize,
        borderRadius: 1,
        flexShrink: 0,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: meta.cellBg(theme),
        color: meta.iconColor(theme),
      }}
    >
      <Icon sx={{ fontSize: size }} />
    </Box>
  );
};

export default WorkflowStatusIconBadge;
